import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useCurrentConfigData from '../dashboardLoading/useCurrentConfig';

const useSetPrice = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const { getCurrentConfigData } = useCurrentConfigData();

    const onPriceError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while setting  price.',
        );
    };

    const onPriceSuccess = (callback?: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Price set successfully');

        if (callback) {
            callback();
        }

        getCurrentConfigData();
    };

    const setPrice = (data: any, callback?: () => void) => {
        const url: HttpConfig = {
            // url: 'ba/v1/configs/set-lookup-unit-price',
            url: 'ba/v1/configs/set-lookup-pricing',
            method: 'post',
            data: data
        };

        request(url, onPriceSuccess(callback), setLoading, onPriceError);
    };

    return { setPrice, loading };
};

export default useSetPrice;
